import React from 'react';
import PropTypes from 'prop-types';

const RENTAL_CENTAUR_HOST = process.env.RENTAL_CENTAUR_HOST || 'https://storable-rcv2.herokuapp.com';

class StandardUnitListing extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hasScrolled: false,
      allowScrollEvent: false,
    };
  }
  componentDidMount() {
    this.boundScrollHandler = this.handleScroll.bind(this);
    window.addEventListener('scroll', this.boundScrollHandler);

    const { corp, site, showApplicableFees } = this.props;

    if (!corp || !site) {
      return;
    }

    this.script = document.createElement('script');
    this.script.type = 'application/javascript';
    this.script.src = '/';
    this.script.async = true;

    document.body.appendChild(this.script);

    this.script.onload = () => {
      this.code = document.createElement('script');
      this.code.type = 'application/javascript';
      this.code.text = `
        try {
          (function () {
            var o = {
              mode: 'unit-listing',
              token: { corp: '${corp}', site: '${site}' },
              url: '${RENTAL_CENTAUR_HOST}',
              show_applicable_fee: ${showApplicableFees},
              parent_element_id: 'rapidstor-app',
              script_path: '/public/application/scripts/publicPanel/bootstrapper/bootstrapper.js',
              ignore_template: false,
              standalone: false
            };
            var t = document.getElementById(o.parent_element_id);
            var s = document.createElement("script");
            var e = Math.round((new Date()).getTime() / 1000);
            window.rapidstor_options = o;
            s.src = o.url + o.script_path + "?epoch=" + e;
            console.log("rsbsl: loading '" + s.src + "'...");
            s.type = 'text/javascript';
            s.async = true;
            s.onload = function () { console.log("rsbsl: loaded '" + s.src + "'."); };
            s.onerror = function (error) {
              console.error(error);
              var parent = document.getElementById(o.parent_element_id);
              var errorNode = document.createElement("h2");
              var contents = document.createTextNode("Our website is currently undergoing maintenance. " +
              "If you'd like to make a reservation or rent a unit, please call us.");
              errorNode.appendChild(contents);
              parent.appendChild(errorNode);
            }
            t.appendChild(s);
          })();
        } catch (e) {
          console.error(e);
        }
      `;

      document.body.appendChild(this.code);
    };
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.boundScrollHandler);

    if (this.script) {
      document.body.removeChild(this.script);
    }

    if (this.code) {
      document.body.removeChild(this.code);
    }

    const rootElement = document.getElementById('rapidstor-app');
    if (rootElement && window.angular) {
      const rootScope = window.angular.element(rootElement).scope().$root;
      rootScope.$destroy();
    }
  }

  handleScroll() {
    if (this.state.allowScrollEvent && this.state.hasScrolled === false) {
      this.setState({ hasScrolled: true });
      window.removeEventListener('scroll', this.boundScrollHandler);
    } else if (this.state.hasScrolled === false) {
      this.setState({ allowScrollEvent: true });
    }
  }

  render() {
    const { content } = this.props;
    const { hasScrolled } = this.state;
    return (
      <div
        dangerouslySetInnerHTML={{ __html: content }}
        className="pb-no-click"
        data-testid="rc2-container"
        style={{
          height: hasScrolled ? 'unset' : '962px',
          overflow: hasScrolled ? 'unset' : 'hidden',
        }}
      />
    );
  }
}

StandardUnitListing.propTypes = {
  id: PropTypes.string,
  script: PropTypes.string,
  corp: PropTypes.string,
  site: PropTypes.string,
  url: PropTypes.string,
  content: PropTypes.string,
  showApplicableFees: PropTypes.bool,
};

export default StandardUnitListing;
